import store from '../store'

import { namespace, types } from '../store/modules/common-store'

window.addEventListener('load', e => {
  store.commit(`${namespace}/${types.SET_LOADED}`, true)
})
